import React from 'react';
import { Box } from 'edenred-ui';
import { useTranslation } from 'react-i18next';

import { SimpleFormStep } from '@epi-pages/LoadBenefit/components/shared/SimpleFormStep';
import { FormStepMode } from '@epi-models/pages/Transfer';
import { DisablableWrapper } from '@epi-pages/LoadBenefit/components/Topup/TopupForm/TopupForm.styles';
import { PaymentMethod } from '@epi-pages/LoadBenefit/components/Topup/TopupForm/PaymentMethod';

interface PaymentMethodProps {
  isLunchTopupRequest: boolean;
  remainingBalance: number;
  formattedMissingAmount: string;
}

export const PaymentMethodStep = ({
  isLunchTopupRequest,
  remainingBalance,
  formattedMissingAmount
}: PaymentMethodProps) => {
  const { t } = useTranslation();

  return (
    <DisablableWrapper disable={isLunchTopupRequest}>
      <SimpleFormStep
        mode={FormStepMode.Outlined}
        stepNumber={5}
        stepTitle={t('containers.deposit_money.topup_tab.form.payment.title')}
        pr="70px"
      >
        <Box width={500} id="deposit_money_topup_step_two_schedule">
          <PaymentMethod
            remainingBalance={remainingBalance}
            formattedMissingAmount={formattedMissingAmount}
          />
        </Box>
      </SimpleFormStep>
    </DisablableWrapper>
  );
};
